import {
  KanalType,
  KundgruppType,
  LamnaOverType,
} from "@/composables/KundserviceAppApiClient";
import type { Option, OptionGroup } from "@/types/form";
import {
  kanalTypeToOption,
  kundgruppTypeToOption,
  lamnaOverTypeToOption,
} from "@/common/constants";

export const ArbetsgivareKanalOptions: Option[] = [
  KanalType.Telefon,
  KanalType.Chat,
  KanalType.Epost,
  KanalType.FysisktMote,
  KanalType.DigitaltMote,
].map(kanalTypeToOption);

export const ArbetsgivareKundgruppOptions: Option[] = [
  KundgruppType.Arbetsgivare,
  KundgruppType.Fackforbund,
  KundgruppType.Arbetsgivarforbund,
].map(kundgruppTypeToOption);

export const ArbetsgivareLamnaOverTillOptionGroups: OptionGroup[] = [
  {
    label: "Internt",
    options: [lamnaOverTypeToOption(LamnaOverType.Kundservice)],
  },
  {
    label: "Externt",
    options: [
      lamnaOverTypeToOption(LamnaOverType.Fora),
      lamnaOverTypeToOption(LamnaOverType.Alecta),
      lamnaOverTypeToOption(LamnaOverType.AfaForsakring),
      lamnaOverTypeToOption(LamnaOverType.CollectumForetag),
    ],
  },
];
